import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import Title from 'Root/App/Title'
import { useCurrentUserId } from 'lib/use-current-user-id'
import filter from 'lodash/filter'
import join from 'lodash/join'

import styles from './index.module.css'

// ----------------------------------------------------------------------------

library.add(faCalendar)

// ----------------------------------------------------------------------------

const Event = ({ content, canManage }) => {
  const userId = useCurrentUserId()
  const hasCompleted =
    content?.presences?.find((pres) => pres.user?.id === userId)?.presence ??
    false
  return (
    <div>
      <div className={styles.wrapper}>
        <div
          className={
            !canManage && hasCompleted
              ? styles.iconContainerCompleted
              : styles.iconContainer
          }
        >
          <FontAwesomeIcon className={styles.icon} icon={['fas', 'calendar']} />
        </div>

        <div>
          <Title size="2XS" maxRows={2}>
            {content.title}
          </Title>
          <Paragraph maxRows={2}>{content.description}</Paragraph>
          <PreTitle className={styles.preTitle}>
            {join(filter([content.label || 'Evento']), ' · ')}
          </PreTitle>
        </div>
      </div>
    </div>
  )
}

export default Event
